import { render, staticRenderFns } from "./CreateCR.vue?vue&type=template&id=18d2f3d2&"
import script from "./CreateCR.vue?vue&type=script&lang=js&"
export * from "./CreateCR.vue?vue&type=script&lang=js&"
import style0 from "./CreateCR.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports